import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const WidgetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`

export const WidgetTitle = styled.div`
  font-size: 0.85rem;
  font-weight: 700;
  color: ${tokens.text.primary};
`

export const WidgetDetailsLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  flex: none;
  border: none;
  background: transparent;
  padding: 0;
  font-size: ${tokens.font.label};
  font-weight: 500;
  color: ${tokens.accent.onDark};
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
  &:focus-visible {
    outline: 2px solid ${tokens.accent.base};
    outline-offset: 2px;
  }
`
